import React, { useState } from 'react';
import Button from '@atlaskit/button';
import AddIcon from '@atlaskit/icon/glyph/add';
import { injectIntlV2 as injectIntl } from '@atlassian/jira-intl/src/v2/inject.tsx';
import type { Intl } from '@atlassian/jira-shared-types/src/general.tsx';
import type { Condition } from '../../../../../../../common/types';
import { SelectField } from './fields/select-field/index.tsx';
import messages from './messages';

export const NewConditionsView = ({
	intl: { formatMessage },
	conditionsList,
	onConditionSelect,
	showLabel,
	listName,
}: Intl & {
	conditionsList: Condition[];
	onConditionSelect: (arg1: Condition) => void;
	showLabel: boolean;
	listName: string;
}) => {
	const [isNewConditionAdded, setIsNewConditionAdded] = useState<boolean>(false); // This state makes sure that only one condition is added at a time

	const setNewConditionAdded = (value: boolean) => {
		setIsNewConditionAdded(value);
	};

	const handleOnChange = () => {
		setNewConditionAdded(true);
	};

	const handleConditionSelect = (condition: Condition) => {
		onConditionSelect(condition);
	};

	const addConditionMessage = formatMessage(messages.addCondition);

	return (
		Boolean(conditionsList.length) && (
			<>
				<SelectField
					conditionsList={conditionsList}
					onSelect={handleConditionSelect}
					isNewConditionAdded={isNewConditionAdded}
					setNewConditionAdded={setNewConditionAdded}
				/>
				<Button
					testId="servicedesk-sla-settings.ui.metrics.metric.editable.form.conditions.condition.add-condition-column"
					appearance="subtle"
					// @ts-expect-error - TS2322 - Type 'Element | null' is not assignable to type 'ReactChild | undefined'.
					iconBefore={showLabel ? null : <AddIcon label="" size="small" />}
					onClick={handleOnChange}
					shouldFitContainer
					aria-label={formatMessage(messages.addConditionAriaLabel, { listName })}
				>
					{showLabel ? addConditionMessage : ''}
				</Button>
			</>
		)
	);
};

export const NewConditions = injectIntl(NewConditionsView);
